// extracted by mini-css-extract-plugin
export default {"firstBreakPoint":"1200px","secondBreakPoint":"725px","disabled":"rgba(138,138,205,.44)","baseColor":"#002f5d","articleFontColor":"#bd0c0c"};